import { formatTableString } from './formatTableString';

/**
 * Formats the country found on a BMAT detection as a two-letter code, according to
 * ISO 3166-1 alpha-2.
 */
export const formatDetectionCountry = (
    detectionCountryMap: Record<string, string>,
    input?: Maybe<string>,
): string => {
    const tableString = formatTableString(input);

    return detectionCountryMap?.[tableString] ?? tableString;
};
